<figure class="mb-0" [class.mockup]="isMockup">
  <img [src]="'assets/img/' + image" [class.img-responsive]="responsive" [ngClass]="imgClass" alt="" />
</figure>
